// 基础数据
import { defineStore } from 'pinia'
import { apiRequest } from '@/api/common'
// import { useBiz_device_getlistApi } from '@/api/maku/biz_device_type'
export const sysStore = defineStore('sys', {
	state: () => ({
		sys_eig: [],
		sys_wave: []
	}),
	actions: {
		setEig(val: any) {
			this.sys_eig = val
		},
		setWave(val: any) {
			this.sys_wave = val
		},
		async getWaveAction() {
			apiRequest('get', 'maku/biz_inspect_wave_def/page?limit=999&page=1').then((res: any) => {
				this.setWave(res.data.list)
			})
		},
		async getEigAction() {
			apiRequest('get', 'maku/biz_inspect_eigen_def/page?limit=999&page=1').then((res: any) => {
				this.setEig(res.data.list)
			})
		}
	}
})
